import { hotTopics } from "@/mocks/scandal";
import SectionHead from "./SectionHead";

const tagColor: Record<string, string> = {
  深扒: "bg-primary-100 text-primary-700",
  人物起底: "bg-background-100 text-foreground-800",
  背景揭秘: "bg-accent-100 text-accent-800",
  内幕: "bg-secondary-100 text-secondary-800",
};

export default function HotBoard() {
  return (
    <section id="rank" className="scroll-mt-24 bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-[1200px] px-4 md:px-6">
        <div className="flex flex-col gap-6 lg:flex-row lg:items-end lg:justify-between">
          <SectionHead
            eyebrow="本周热议 / HOT BOARD"
            title="正在被深扒的 8 件事"
            desc="按热度实时汇总，数字会说话：从数据注水到改名重置，榜单即风向。"
          />
          <a
            href="#rank"
            className="inline-flex items-center gap-2 whitespace-nowrap rounded-md border border-foreground-950/10 bg-background-50 px-4 py-2 text-sm text-foreground-700 transition-colors hover:border-foreground-950/25"
          >
            查看完整热榜
            <i className="ri-arrow-right-line text-sm" />
          </a>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-3 lg:grid-cols-2">
          {hotTopics.map((t, i) => (
            <a
              key={t.rank}
              href="#rank"
              className="group flex items-center gap-4 rounded-lg border border-foreground-950/6 bg-background-100/40 px-4 py-3.5 transition-colors hover:border-foreground-950/15 hover:bg-background-100"
            >
              <span
                className={
                  "flex w-8 shrink-0 items-center justify-center font-heading text-xl font-black " +
                  (i < 3 ? "text-primary-600" : "text-foreground-300")
                }
              >
                {String(t.rank).padStart(2, "0")}
              </span>
              <div className="min-w-0 flex-1">
                <p className="truncate text-sm font-medium text-foreground-950 transition-colors group-hover:text-primary-700">
                  {t.title}
                </p>
                <div className="mt-1.5 flex items-center gap-2">
                  <span className={"rounded-full px-2 py-0.5 font-label text-[11px] " + tagColor[t.tag]}>{t.tag}</span>
                  <span className="flex items-center gap-1 font-label text-[11px] text-foreground-500">
                    <i className="ri-fire-line text-primary-500" />
                    {t.heat}
                  </span>
                </div>
              </div>
              <span className="hidden shrink-0 items-center gap-1 whitespace-nowrap font-label text-[11px] text-accent-700 sm:flex">
                <i className="ri-arrow-up-line text-sm" />
                {t.delta}
              </span>
              <i className="ri-arrow-right-s-line shrink-0 text-lg text-foreground-300 transition-colors group-hover:text-foreground-950" />
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}